import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { Card, CardBody, CardHeader } from "reactstrap";

/* ---------------- HELPERS ---------------- */

const isToday = (dateStr) => {
  const today = new Date().toISOString().split("T")[0];
  return dateStr === today;
};

const getCurrentShift = () => {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 14) return 1;
  if (hour >= 14 && hour < 22) return 2;
  return 3;
};

/* ---------------- CUSTOM TOOLTIP ---------------- */

const StatusTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;

  const data = payload[0].payload;

  return (
    <div
      style={{
        background: "#fff",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        maxWidth: "300px",
      }}
    >
      <p><strong>Time:</strong> {label}</p>

      {data.status === "running" && (
        <p style={{ color: "green", fontWeight: 600 }}>Running</p>
      )}

      {data.status === "stopped" && (
        <>
          <p style={{ color: "red", fontWeight: 600 }}>Stopped</p>
          <strong>Reason:</strong>
          <ul style={{ paddingLeft: "18px", margin: 0 }}>
            {(data.reason || ["No reason"]).map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

/* ---------------- COMPONENT ---------------- */

const MachineStatusLineChart = ({
  selectedDate,
  selectedShift,
  selectedMachine,
}) => {
  const [data, setData] = useState([]);
  const getApiDate = (selectedDate) => {
  if (selectedDate === "2026-08-17") {
    return "2026-06-01";
  }

  return selectedDate;
};
  const fetchStatus = async () => {
    if (!selectedDate || !selectedShift || !selectedMachine) return;

    try {
       const apiDate = getApiDate(selectedDate);
      const res = await fetch(
        `https://api.hanoch.in/api/live-machine-status/?machine_id=${selectedMachine}&date=${apiDate}&shift=${selectedShift}`
      );

      const json = await res.json();

      const isLiveShift =
        isToday(selectedDate) &&
        Number(selectedShift) === getCurrentShift();

      const nowTime = new Date().toTimeString().slice(0, 5); // HH:mm

      const transformed =
        json.data?.map((item) => {
          const time = item.time.slice(0, 5);
          const isFuture = isLiveShift && time > nowTime;
          const isRunning = item.running === 1;

          return {
            time,
            runningLine: !isFuture && isRunning ? 1 : null,
            stoppedLine: !isFuture && !isRunning ? 1 : null,
            status: isFuture ? null : item.status,
            reason: item.reason,
          };
        }) || [];

      setData(transformed);
    } catch (err) {
      console.error(err);
      setData([]);
    }
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 60000);
    return () => clearInterval(interval);
  }, [selectedDate, selectedShift, selectedMachine]);

  return (
    <Card>
      <CardHeader>
        <h5>Machine Status Timeline</h5>
      </CardHeader>
      <CardBody>
        <div style={{ position: "relative", zIndex: 10 }}>
        <ResponsiveContainer width="100%" height={120}>
          <LineChart data={data}>
            {/* <CartesianGrid strokeDasharray="3 3"
              vertical={false}  /> */}
            <XAxis dataKey="time" />
            <YAxis hide domain={[0, 1]} />
            <Tooltip content={<StatusTooltip />} />

            {/* Running */}
            <Line
              type="stepAfter"
              dataKey="runningLine"
              stroke="#28a745"
              strokeWidth={3}
              dot={false}
              connectNulls={false}
                isAnimationActive={false}
            />

            {/* Stopped */}
            <Line
              type="stepAfter"
              dataKey="stoppedLine"
              stroke="#dc3545"
              strokeWidth={3}
              dot={false}
              connectNulls={false}
                isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
        </div>
      </CardBody>
    </Card>
  );
};

export default MachineStatusLineChart;
